/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = none, 1 = rehabilitation, 2 = demolition.
 * @export
 */
export const BuildingFuture = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type BuildingFuture = typeof BuildingFuture[keyof typeof BuildingFuture];


export function instanceOfBuildingFuture(value: any): boolean {
    for (const key in BuildingFuture) {
        if (Object.prototype.hasOwnProperty.call(BuildingFuture, key)) {
            if (BuildingFuture[key as keyof typeof BuildingFuture] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BuildingFutureFromJSON(json: any): BuildingFuture {
    return BuildingFutureFromJSONTyped(json, false);
}

export function BuildingFutureFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuildingFuture {
    return json as BuildingFuture;
}

export function BuildingFutureToJSON(value?: BuildingFuture | null): any {
    return value as any;
}

export function BuildingFutureToJSONTyped(value: any, ignoreDiscriminator: boolean): BuildingFuture {
    return value as BuildingFuture;
}

